import { useMemo } from "react";
import ChipStatus from "../ChipStatus";
import SingleSelector from "../SingleSelector";
import { useTranslation } from "@/langs/useTranslation";

const useDeviceNamingStatusOptions = () => {
  const { t } = useTranslation();

  return [
    { id: 0, name: t({ defaultMessage: "启用" }) },
    { id: 1, name: t({ defaultMessage: "禁用" }) }
  ];
};

const DeviceNamingStatus = ({ name, value, onChange }) => {
  const { t } = useTranslation();
  const options = useDeviceNamingStatusOptions();

  return (
    <SingleSelector
      placeholder={t({ defaultMessage: "选择状态" })}
      clearable
      options={options}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

export const DeviceNamingChipStatus = ({ status }) => {
  const options = useDeviceNamingStatusOptions();
  const option = useMemo(() => {
    return options.find(option => option.id === status);
  }, [status]);

  const type = {
    0: "success",
    1: "default"
  };

  if (!option) {
    return null;
  }

  return <ChipStatus type={type[option.id]} label={option.name} />;
};

export default DeviceNamingStatus;
